module.exports = __webpack_public_path__ + "static/img/cooperation_bg.1f0544e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/cooperation_bg.png
// module id = REB7
// module chunks = 44